module.exports = __webpack_public_path__ + "img/download.9f9ab128.svg";